import React, {useContext,useEffect} from 'react';
import { Col } from 'antd';
import ChartRenderer from '../components/ChartRenderer';
import Dashboard from '../components/Dashboard';
import DashboardItem from '../components/DashboardItem';
import {RoleContext} from "../contexts/RoleContext";

const DashboardItems = [
  {
    id: 1,
    name: 'New users for last 30 days',//Новые пользователи в чате по дням за последние 30 дней
    vizState: {
      query: {
        "measures":["ImbachatUsers.count"],
        "timeDimensions":[
          {
            "dimension":"ImbachatUsers.createdAt",
            "granularity":"day",
            "dateRange":"Last 30 days"
          }
        ],
        "filters":[ 
        ],
        "order":{}
      },
      chartType: 'line',
    },
  },
  {
    id: 2,
    name: 'New dialogs for last 30 days',//Новые диалоги в чате по дням за последние 30 дней
    vizState: {
      query: {
        "measures":["ImbachatRoominfo.count"],
        "timeDimensions":[
          {
            "dimension":"ImbachatRoominfo.createdAt",
            "granularity":"day",
            "dateRange":"Last 30 days"
          }
        ],
        "filters":[ 
        ],
        "order":{}
      },
      chartType: 'line',
    },
  },
  {
    id: 3,
    name: 'Average api response time',//Среднее время ответов на апи запросы
    vizState: {
      query: {
        "measures":[
          "ImbachatAnalyticsWidgets.apiTimeCallMax",
          "ImbachatAnalyticsWidgets.apiTimeCallAvg"
        ],
        "timeDimensions":[
          {
            "dimension":"ImbachatAnalyticsWidgets.createdAt",
            "granularity":"day",
            "dateRange":"Last 30 days"
          }
        ],
        "filters":[
          {"member":"ImbachatAnalyticsWidgets.event","operator":"equals","values":["apiCall"]}
        ],"order":{}},
      chartType: 'line',
    },
  },
  {
    id: 4,
    name: 'Count of API requests to website from chat',//Количество АПИ запросов к сайту от чата
    vizState: {
      query: {
        "measures":[
          "ImbachatAnalyticsWidgets.count"
        ],
        "timeDimensions":[
          {
            "dimension":"ImbachatAnalyticsWidgets.createdAt",
            "granularity":"day",
            "dateRange":"Last 30 days"
          }
        ],
        "filters":[
          {"member":"ImbachatAnalyticsWidgets.event","operator":"equals","values":["apiCall"]}
        ],"order":{}
      },
      chartType: 'line',
    },
  },
  {
    id: 5,
    name: 'Widget loads from users',//Загрузки виджета пользователями
    vizState: {
      query: {
        "measures":[
          "ImbachatAnalyticsWidgets.count"
        ],
        "timeDimensions":[
          {
            "dimension":"ImbachatAnalyticsWidgets.createdAt",
            "granularity":"day",
            "dateRange":"Last 30 days"
          }
        ],
        "filters":[
          {"member":"ImbachatAnalyticsWidgets.event","operator":"equals","values":["load"]}
        ],"order":{}
      },
      chartType: 'line',
    },
  },
  {
    id: 6,
    name: 'User`s messages',//Сообщения пользователей
    vizState: {
      query: {
        "measures":["ImbachatMessages.count"],
        "timeDimensions":[
          {
            "dimension":"ImbachatMessages.createdAt",
            "granularity":"day",
            "dateRange":"Last 30 days"
          }
        ],
        "filters":[
          
        ],
        "order":{}
      },
      chartType: 'line',
    },
  },
  {
    id: 7,
    name: 'Most active users',//Самые активные пользователи
    vizState: {
      query: {
        "measures":["ImbachatMessages.count"],
        "timeDimensions":[
          {"dimension":"ImbachatMessages.createdAt","dateRange":"Last 30 days"}
        ],
        "dimensions":["ImbachatUsers.login",],
        "limit":200,
        "order":{"ImbachatMessages.count":"desc"}
      },
      chartType: 'line',
    },
  },
  {
    id: 8,
    name: 'Most popular rooms',//Самые популярные комнаты
    vizState: {
      query: {
        "measures":["ImbachatMessages.count"],
        "timeDimensions":[
          {"dimension":"ImbachatMessages.createdAt","dateRange":"Last 30 days"}
        ],
        "dimensions":["ImbachatRoominfo.name"], 
        "order":{"ImbachatMessages.count":"desc"}
      },
      chartType: 'line',
    },
  },
  {
    id: 9,
    name: 'Most active users',
    vizState: {
      query: {
        "measures":["ImbachatMessages.count"],
        "timeDimensions":[
          {"dimension":"ImbachatMessages.createdAt","dateRange":"Last 30 days"}
        ],
        "dimensions":["ImbachatUsers.remoteUserId", "ImbachatUsers.login",],
        "limit":200,
        "order":{"ImbachatMessages.count":"desc"}
      },
      chartType: 'table',
    },
  },
  {
    id: 10,
    name: 'Most popular rooms',
    vizState: {
      query: {
        "measures":["ImbachatMessages.count"],
        "timeDimensions":[
          {"dimension":"ImbachatMessages.createdAt","dateRange":"Last 30 days"}
        ],
        "dimensions":["ImbachatRoominfo.name"],
        "limit":200,
        "order":{"ImbachatMessages.count":"desc"}
      },
      chartType: 'table',
    },
  },
];

const DashboardPageNew = (props) => {
  //Проверка авторизован ли пользователь
  const {getRole} = useContext(RoleContext);
    const role = getRole()

  useEffect(() => {
      const user_id = localStorage.getItem("comet-user-id");
        const token = localStorage.getItem('comet-token')
      if(window.imbaApi){
        window.imbaApi.load({
          user_id: user_id,
          token: token
          })
      }
      setInterval(()=>{
        if(document.querySelector('#imbachat') && document.querySelector("#imbachat").style.display != 'block') document.querySelector("#imbachat").style.display = 'block'
        
        },1000)
  }, []);

  const dashboardItem = (item) => (
    <Col
      span={24}
      lg={12}
      key={item.id}
      style={{
        marginBottom: '24px',
      }}
    >
      <DashboardItem title={item.name}>
        <ChartRenderer vizState={item.vizState} />
      </DashboardItem>
    </Col>
  );

  const Empty = () => (
    <div
      style={{
        textAlign: 'center',
        padding: 12,
      }}
    >
      <h2>
        There are no charts on this dashboard. Use Playground Build to add one.
      </h2>
    </div>
  );


 
  return DashboardItems.length ? (
    <Dashboard dashboardItems={DashboardItems}>
      {DashboardItems.map(dashboardItem)}
    </Dashboard>
  ) : (
    <Empty />
  );
};

export default DashboardPageNew;
